import React, { useState, useEffect } from 'react';
import api from '../api';
import useResponsive from '../hooks/useResponsive';

const API_URL = 'https://api.otoflow.caliskanservis.com';

export default function TTSOnay({ kullanici, cikisYap }) {
  const { isMobile, isNarrow } = useResponsive();
  const [ekran, setEkran]         = useState('ihaleler'); // ihaleler | araclar | arac
  const [ihaleler, setIhaleler]   = useState([]);
  const [araclar, setAraclar]     = useState([]);
  const [kalemler, setKalemler]   = useState([]);
  const [fotograflar, setFotograflar] = useState([]);
  const [secilenIhale, setSecilenIhale] = useState(null);
  const [secilenArac, setSecilenArac]   = useState(null);
  const [yukleniyor, setYukleniyor]     = useState(false);
  const [sekme, setSekme]               = useState('kalemler'); // kalemler | fotograflar
  const [onayModal, setOnayModal]       = useState(false);
  const [onayForm, setOnayForm]         = useState({ kul_adi: '', sifre: '', not: '' });
  const [onayYukleniyor, setOnayYukleniyor] = useState(false);
  const [onayHata, setOnayHata]         = useState('');
  const [mevcutOnay, setMevcutOnay]     = useState(null);
  const [buyukFoto, setBuyukFoto]       = useState(null);
  const [fotoTip, setFotoTip]           = useState('sokullen');

  const FOTO_TIPLER = [
    { key: 'sokullen', label: 'Sökülen' },
    { key: 'takilan',  label: 'Takılan' },
    { key: 'genel',    label: 'Genel' },
  ];

  useEffect(() => { yukleIhaleler(); }, []);

  const yukleIhaleler = async () => {
    setYukleniyor(true);
    try {
      const { data } = await api.get('/ihale');
      setIhaleler(data || []);
    } catch {}
    setYukleniyor(false);
  };

  const ihaleAc = async ihale => {
    setSecilenIhale(ihale);
    setYukleniyor(true);
    try {
      const { data } = await api.get(`/ihale/${ihale.id}/araclar`);
      // Her araç için onay durumunu kontrol et
      const araclarVeOnay = await Promise.all((data || []).map(async arac => {
        try {
          const { data: onay } = await api.get(`/ihale/araclar/${arac.id}/onay`);
          return { ...arac, _onaylandi: !!onay };
        } catch { return { ...arac, _onaylandi: false }; }
      }));
      setAraclar(araclarVeOnay);
    } catch {}
    setYukleniyor(false);
    setEkran('araclar');
  };

  const aracAc = async arac => {
    setSecilenArac(arac);
    setYukleniyor(true);
    try {
      const [k, f, o] = await Promise.all([
        api.get(`/ihale/araclar/${arac.id}/kalemler`),
        api.get(`/ihale/araclar/${arac.id}/fotograflar`),
        api.get(`/ihale/araclar/${arac.id}/onay`).catch(() => ({ data: null })),
      ]);
      setKalemler(k.data || []);
      setFotograflar(f.data || []);
      setMevcutOnay(o.data || null);
    } catch {}
    setYukleniyor(false);
    setSekme('kalemler');
    setEkran('arac');
  };

  const onayGonder = async () => {
    if (!onayForm.kul_adi || !onayForm.sifre) return setOnayHata('Kullanıcı adı ve şifre zorunlu');
    setOnayYukleniyor(true);
    setOnayHata('');
    try {
      // Şifre doğrula
      await api.post('/auth/verify', { kul_adi: onayForm.kul_adi, sifre: onayForm.sifre });
      // Onay kaydet
      const { data } = await api.post(`/ihale/araclar/${secilenArac.id}/onay`, {
        tur: 'web',
        not_alani: onayForm.not,
      });
      setMevcutOnay({ onaylayan: data.onaylayan, tarih: data.tarih, not_alani: onayForm.not });
      setOnayModal(false);
      setOnayForm({ kul_adi: '', sifre: '', not: '' });
      alert('✅ Onay başarıyla kaydedildi');
    } catch (e) {
      setOnayHata(e.response?.data?.hata || 'Kullanıcı adı veya şifre hatalı');
    }
    setOnayYukleniyor(false);
  };

  // ── HEADER ──────────────────────────────────────────────────────────────────
  const Header = ({ baslik, geri }) => (
    <div style={{ background: 'var(--ink)', position: 'sticky', top: 0, zIndex: 200 }}>
      <div style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: isMobile ? '10px 14px' : '0 20px',
        display: 'flex',
        alignItems: 'center',
        minHeight: isMobile ? 'auto' : 50,
        gap: 12,
        flexWrap: isMobile ? 'wrap' : 'nowrap',
      }}>
        {geri && <button onClick={geri} style={navBtn()}>← Geri</button>}
        <span style={{
          fontFamily: "'Barlow Condensed',sans-serif",
          fontSize: 18,
          fontWeight: 900,
          color: 'white',
          letterSpacing: -.5,
          flex: isMobile ? '1 1 100%' : 1,
          order: isMobile ? -1 : 0,
        }}>
          {baslik}
        </span>
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,.5)', fontWeight: 700 }}>ONAY MERCİİ</span>
        <button onClick={cikisYap} style={{ ...navBtn(), color: 'rgba(255,100,100,.8)' }}>Çıkış</button>
      </div>
    </div>
  );

  // ── İHALE LİSTESİ ───────────────────────────────────────────────────────────
  if (ekran === 'ihaleler') return (
    <div style={{ fontFamily: "'Barlow',sans-serif", background: 'var(--bg)', minHeight: '100vh' }}>
      <Header baslik="İhale Listesi" />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 20px' }}>
        {yukleniyor ? <Yukleniyor /> : ihaleler.map(ihale => (
          <div key={ihale.id} onClick={() => ihaleAc(ihale)} style={kartStyle()}>
            <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 20, fontWeight: 900, marginBottom: 4 }}>{ihale.ad}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>
              {ihale.arac_sayisi || 0} araç
              {ihale.baslangic_tar && ` · ${new Date(ihale.baslangic_tar).toLocaleDateString('tr-TR')}`}
            </div>
            <div style={{ marginTop: 8 }}>
              <span style={durumEtiketi(ihale.durum)}>{ihale.durum === 'aktif' ? 'Aktif' : 'Kapalı'}</span>
            </div>
          </div>
        ))}
        {!yukleniyor && ihaleler.length === 0 && <Bos mesaj="İhale bulunamadı" />}
      </div>
    </div>
  );

  // ── ARAÇ LİSTESİ ────────────────────────────────────────────────────────────
  if (ekran === 'araclar') return (
    <div style={{ fontFamily: "'Barlow',sans-serif", background: 'var(--bg)', minHeight: '100vh' }}>
      <Header baslik={secilenIhale?.ad} geri={() => setEkran('ihaleler')} />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 20px' }}>
        {yukleniyor ? <Yukleniyor /> : araclar.map(arac => (
          <div key={arac.id} onClick={() => aracAc(arac)} style={{
            ...kartStyle(),
            borderColor: arac._onaylandi ? 'rgba(39,174,96,.4)' : 'var(--border2)',
            background: arac._onaylandi ? 'rgba(39,174,96,.06)' : 'var(--surface)',
          }}>
            <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: 12, flexDirection: isMobile ? 'column' : 'row' }}>
              <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 20, fontWeight: 900, color: arac._onaylandi ? '#27ae60' : 'var(--ink)' }}>{arac.plaka}</div>
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>{arac.marka} {arac.model}</div>
              <div style={{ marginLeft: isMobile ? 0 : 'auto', display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                {arac._onaylandi && (
                  <span style={{ fontSize: 10, fontWeight: 800, color: '#27ae60', background: 'rgba(39,174,96,.12)', border: '1px solid rgba(39,174,96,.3)', borderRadius: 2, padding: '2px 7px', letterSpacing: .3 }}>✅ Onaylandı</span>
                )}
                <span style={durumEtiketi(arac.durum)}>{arac.durum === 'tamamlandi' ? 'Tamamlandı' : 'Devam'}</span>
              </div>
            </div>
            {arac.bolge && <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>{arac.bolge}</div>}
          </div>
        ))}
        {!yukleniyor && araclar.length === 0 && <Bos mesaj="Araç bulunamadı" />}
      </div>
    </div>
  );

  // ── ARAÇ DETAYI ─────────────────────────────────────────────────────────────
  if (ekran === 'arac') return (
    <div style={{ fontFamily: "'Barlow',sans-serif", background: 'var(--bg)', minHeight: '100vh' }}>
      <Header baslik={secilenArac?.plaka} geri={() => setEkran('araclar')} />

      {/* Araç bilgi kartı */}
      <div style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '14px' : '16px 20px', display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fill, minmax(160px,1fr))', gap: 12 }}>
          {[
            { label: 'Servis Form No', val: secilenArac?.servis_form_no },
            { label: 'Marka / Model', val: `${secilenArac?.marka || ''} ${secilenArac?.model || ''}` },
            { label: 'Bölge', val: secilenArac?.bolge },
            { label: 'Talep No', val: secilenArac?.talep_no },
            { label: 'Giriş', val: secilenArac?.giris_tarihi ? new Date(secilenArac.giris_tarihi).toLocaleDateString('tr-TR') : '—' },
            { label: 'Çıkış', val: secilenArac?.cikis_tarihi ? new Date(secilenArac.cikis_tarihi).toLocaleDateString('tr-TR') : '—' },
          ].map(({ label, val }) => (
            <div key={label}>
              <div style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 2 }}>{label}</div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{val || '—'}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Onay durumu */}
      {mevcutOnay ? (
        <div style={{ background: 'rgba(39,174,96,.08)', borderBottom: '1px solid rgba(39,174,96,.2)', padding: '10px 20px' }}>
          <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 18 }}>✅</span>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#27ae60' }}>Onaylandı</div>
              <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                {mevcutOnay.onaylayan} · {mevcutOnay.tarih ? new Date(mevcutOnay.tarih).toLocaleString('tr-TR') : ''}
              </div>
            </div>
            <button onClick={() => setOnayModal(true)} style={{ marginLeft: isMobile ? 0 : 'auto', width: isMobile ? '100%' : 'auto', ...btnSecondary() }}>Güncelle</button>
          </div>
        </div>
      ) : (
        <div style={{ background: 'rgba(231,76,60,.06)', borderBottom: '1px solid rgba(231,76,60,.15)', padding: '10px 20px' }}>
          <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 18 }}>⏳</span>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#e74c3c' }}>Onay Bekliyor</div>
            <button onClick={() => setOnayModal(true)} style={{ marginLeft: isMobile ? 0 : 'auto', width: isMobile ? '100%' : 'auto', ...btnPrimary() }}>Onarımı Onayla</button>
          </div>
        </div>
      )}

      {/* Sekmeler */}
      <div style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)', position: 'sticky', top: 50, zIndex: 100 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '0 14px' : '0 20px', display: 'flex', overflowX: 'auto', scrollbarWidth: 'none' }}>
          {['kalemler', 'fotograflar'].map(s => (
            <button key={s} onClick={() => setSekme(s)} style={{
              background: 'none', border: 'none', padding: '14px 18px', cursor: 'pointer',
              fontFamily: "'Barlow Condensed',sans-serif", fontSize: 14, fontWeight: 800,
              letterSpacing: .5, textTransform: 'uppercase',
              color: sekme === s ? '#2980b9' : 'var(--muted)',
              borderBottom: sekme === s ? '2px solid #2980b9' : '2px solid transparent',
            }}>
              {s === 'kalemler' ? `Kalemler (${kalemler.length})` : `Fotoğraflar (${fotograflar.length})`}
            </button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '20px' }}>
        {sekme === 'kalemler' && (
          kalemler.length === 0 ? <Bos mesaj="Kalem eklenmemiş" /> : isMobile ? (
            <div style={{ display: 'grid', gap: 10 }}>
              {kalemler.map(k => (
                <div key={k.id} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, padding: 14 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start', marginBottom: 8 }}>
                    <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 18, fontWeight: 900, color: '#e67e22' }}>
                      {k.sozlesme_no || '—'}
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'right' }}>{k.miktar} {k.olcu_birimi}</div>
                  </div>
                  {k.parca_kodu && <div style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--muted)', marginBottom: 6 }}>{k.parca_kodu}</div>}
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>{k.aciklama}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)' }}>{k.marka || 'Marka belirtilmedi'}</div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, overflow: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: 'var(--surface2)' }}>
                    {['Kalem No', 'Parça Kodu', 'Açıklama', 'Marka', 'Miktar'].map(h => (
                      <th key={h} style={{ padding: '8px 10px', textAlign: 'left', fontSize: 10, fontWeight: 800, letterSpacing: .5, textTransform: 'uppercase', color: 'var(--muted)', borderBottom: '1px solid var(--border2)' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {kalemler.map((k, i) => (
                    <tr key={k.id} style={{ borderBottom: '1px solid var(--border)', background: i % 2 === 0 ? '' : 'var(--surface2)' }}>
                      <td style={{ padding: '8px 10px', fontWeight: 800, color: '#e67e22' }}>{k.sozlesme_no || '—'}</td>
                      <td style={{ padding: '8px 10px', fontFamily: 'monospace', fontSize: 11 }}>{k.parca_kodu}</td>
                      <td style={{ padding: '8px 10px' }}>{k.aciklama}</td>
                      <td style={{ padding: '8px 10px', color: 'var(--muted)' }}>{k.marka}</td>
                      <td style={{ padding: '8px 10px' }}>{k.miktar} {k.olcu_birimi}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}

        {sekme === 'fotograflar' && (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
              {FOTO_TIPLER.map(t => (
                <button key={t.key} onClick={() => setFotoTip(t.key)} style={{
                  padding: '6px 14px', borderRadius: 4, cursor: 'pointer', fontSize: 12, fontWeight: 700,
                  border: fotoTip === t.key ? '2px solid #2980b9' : '1px solid var(--border2)',
                  background: fotoTip === t.key ? 'rgba(41,128,185,.1)' : 'var(--surface)',
                  color: fotoTip === t.key ? '#2980b9' : 'var(--ink)',
                }}>
                  {t.label} ({fotograflar.filter(f => f.tip === t.key).length})
                </button>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: isNarrow ? '1fr 1fr' : 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
              {fotograflar.filter(f => f.tip === fotoTip).map(f => (
                <div key={f.id} onClick={() => setBuyukFoto(f)} style={{ borderRadius: 6, overflow: 'hidden', border: '1px solid var(--border)', cursor: 'pointer' }}>
                  <img src={`${API_URL}${f.dosya_url}`} alt="" style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', display: 'block' }} />
                </div>
              ))}
              {fotograflar.filter(f => f.tip === fotoTip).length === 0 && <Bos mesaj="Bu kategoride fotoğraf yok" />}
            </div>
          </>
        )}
      </div>

      {/* Onay Modal */}
      {onayModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'var(--surface)', borderRadius: 10, padding: isMobile ? 18 : 28, width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
            <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: 20, fontWeight: 900, marginBottom: 6 }}>Onarım Onayı</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 20 }}>
              Onaylamak için kullanıcı adı ve şifrenizi girin.
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 }}>
              <div>
                <label style={lbl()}>Kullanıcı Adı</label>
                <input value={onayForm.kul_adi} onChange={e => setOnayForm(f => ({...f, kul_adi: e.target.value}))}
                  style={inp()} autoFocus autoComplete="username" />
              </div>
              <div>
                <label style={lbl()}>Şifre</label>
                <input type="password" value={onayForm.sifre} onChange={e => setOnayForm(f => ({...f, sifre: e.target.value}))}
                  style={inp()} autoComplete="current-password"
                  onKeyDown={e => e.key === 'Enter' && onayGonder()} />
              </div>
              <div>
                <label style={lbl()}>Not (opsiyonel)</label>
                <textarea value={onayForm.not} onChange={e => setOnayForm(f => ({...f, not: e.target.value}))}
                  rows={3} style={{ ...inp(), resize: 'vertical' }} placeholder="Onay notu..." />
              </div>
            </div>
            {onayHata && (
              <div style={{ background: 'rgba(231,76,60,.08)', border: '1px solid rgba(231,76,60,.3)', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#e74c3c', marginBottom: 12 }}>{onayHata}</div>
            )}
            <div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column-reverse' : 'row' }}>
              <button onClick={() => { setOnayModal(false); setOnayHata(''); setOnayForm({ kul_adi: '', sifre: '', not: '' }); }} style={{ ...btnSecondary(), flex: 1, width: '100%' }}>İptal</button>
              <button onClick={onayGonder} disabled={onayYukleniyor} style={{ ...btnPrimary(), flex: 1, width: '100%' }}>
                {onayYukleniyor ? 'Doğrulanıyor...' : '✓ Onayla'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Büyük fotoğraf */}
      {buyukFoto && (
        <div onClick={() => setBuyukFoto(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.9)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: isMobile ? 12 : 20 }}>
          <img src={`${API_URL}${buyukFoto.dosya_url}`} alt="" style={{ maxWidth: '100%', maxHeight: '90vh', borderRadius: 6 }} onClick={e => e.stopPropagation()} />
          <button onClick={() => setBuyukFoto(null)} style={{ position: 'absolute', top: isMobile ? 12 : 20, right: isMobile ? 12 : 20, background: 'rgba(255,255,255,.15)', border: 'none', color: 'white', borderRadius: 50, width: 36, height: 36, fontSize: 18, cursor: 'pointer' }}>✕</button>
        </div>
      )}
    </div>
  );

  return null;
}

const Yukleniyor = () => <div style={{ textAlign: 'center', padding: 40, color: 'var(--muted)', fontSize: 13 }}>Yükleniyor...</div>;
const Bos = ({ mesaj }) => <div style={{ textAlign: 'center', padding: 40, color: 'var(--muted)', fontSize: 13 }}>{mesaj}</div>;
const kartStyle = () => ({
  background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 8,
  padding: '18px 20px', marginBottom: 12, cursor: 'pointer', transition: 'all .15s',
  onMouseEnter: e => { e.currentTarget.style.borderColor = '#2980b9'; },
});
const durumEtiketi = durum => ({
  fontSize: 10, fontWeight: 800, letterSpacing: .5, textTransform: 'uppercase',
  padding: '2px 8px', borderRadius: 2,
  background: durum === 'aktif' || durum === 'devam' ? 'rgba(41,128,185,.12)' : 'rgba(39,174,96,.12)',
  color: durum === 'aktif' || durum === 'devam' ? '#2980b9' : '#27ae60',
  border: `1px solid ${durum === 'aktif' || durum === 'devam' ? 'rgba(41,128,185,.3)' : 'rgba(39,174,96,.3)'}`,
  display: 'inline-block',
});
const navBtn     = () => ({ background: 'rgba(255,255,255,.08)', border: '1px solid rgba(255,255,255,.15)', color: 'rgba(255,255,255,.8)', padding: '6px 12px', borderRadius: 3, cursor: 'pointer', fontFamily: "'Barlow Condensed',sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' });
const btnPrimary = () => ({ background: '#2980b9', border: 'none', color: 'white', padding: '9px 20px', borderRadius: 4, cursor: 'pointer', fontFamily: "'Barlow Condensed',sans-serif", fontSize: 13, fontWeight: 800, letterSpacing: .5 });
const btnSecondary = () => ({ background: 'var(--surface2)', border: '1px solid var(--border2)', color: 'var(--ink)', padding: '9px 20px', borderRadius: 4, cursor: 'pointer', fontFamily: "'Barlow Condensed',sans-serif", fontSize: 13, fontWeight: 700 });
const lbl = () => ({ display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: .5, textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 5 });
const inp = () => ({ width: '100%', padding: '9px 12px', border: '1px solid var(--border2)', borderRadius: 4, fontSize: 13, fontFamily: "'Barlow',sans-serif", background: 'var(--surface)', color: 'var(--ink)', boxSizing: 'border-box' });
